module.exports = __webpack_public_path__ + "static/media/time.566a7f68.svg";